import httpAuth from "@/common/http-common";
import { 
  AlertZone,
  PatientSummary,
  Utox,
  SurveyGroup,
  SurveyGroupParticipant,
  ParticipantSynopsisResponse,
  ParticipantSynopsisRequest
} from "@/views/summary/summary.types";

class SummaryService {
  async getAlertZones(alertZoneType: number, clientId: number) {
    const { data } = await httpAuth().get<AlertZone[]>(
      '/Dashboard/GetAlertZones', { params: { 
        alertZoneType: alertZoneType,
        clientId: clientId
      } 
    });
    return data;
  }

  async getPatientSummary(clientId: number, show: boolean, timezone: string) {
    const { data } = await httpAuth().get<PatientSummary[]>(
      '/SummaryDashboard/GetPatientSummary', { params: {
        clientId: clientId,
        show: show,
        timezone: timezone
      } 
    });
    return data;
  }

  async getUtoxById(startDate: string, participantId: number, clientId: number) {
    const { data } = await httpAuth().get<Utox>(
      '/SummaryDashboard/GetUtoxById', { params: { 
        startDate: startDate,
        participantId: participantId,
        clientId: clientId
      } 
    });
    return data;
  }

  async getSurveyGroups(clientId: number) {
    const { data } = await httpAuth().get<SurveyGroup[]>(
      '/SummaryDashboard/GetSurveyGroups', { params: {
        clientId: clientId
      }
    });
    return data;
  }

  async AddSurveyGroupParticipantMap(surveyGroupParticipant: SurveyGroupParticipant) {
    const { data } = await httpAuth().post(
      `/SummaryDashboard/AddSurveyGroupParticipantMap`, 
      surveyGroupParticipant 
    );
    return data;
  }

  async UpdateParticipantShow(clientId: number, participantId: number, show: boolean) {
    const { data } = await httpAuth().post(
      `/SummaryDashboard/UpdateParticipantShow`, {
        clientId: clientId,
        participantId: participantId,
        show: show
    });
    return data;
  }

  async getAiInsight(participantSynopsisRequest: ParticipantSynopsisRequest) {
    const { data } = await httpAuth().post<ParticipantSynopsisResponse>(
      '/Vertex/GetParticipantSynopsis', 
      participantSynopsisRequest
    );
    return data;
  }
}

export default new SummaryService();